export const validatePhone = (phone: string | number) => {
    const phoneToString = String(phone);
    const regexToTest = new RegExp(/^(9[1-9]|[2][2-3])[0-9]{3}[0-9]{4}$/);
    const match = phoneToString.match(regexToTest);
    return match !== null;
};